import {Button, Modal} from "react-bootstrap";
import React, {ChangeEvent, useContext, useEffect, useState} from "react";
import {AppContext} from "../../../../appContext/AppContext";
import {IconButtonSave} from "../../../../component/IconSvg";
import {TypeYeuCau} from "../models/keHoach";
import ModelHeader from "../../../../component/ModelHeader";
import {TableCustom} from "../../../../component/table/table-custom/TableCustom";
import {KeHoachDialogColumns} from "../../columns";
import {CODE, DEFAULT_PAGE_INDEX, KEY, SELECTION_MODE} from "../../../../utils/Constant";
import {TablePagination} from "../../../../component/table/components/TablePagination";
import {handlePagesChange, handleRowsPerPageChange, rowsForPage} from "../../../../utils/PageUtils";
import AutocompleteObjectV2 from "../../../../component/AutocompleteObjectV2";
import InputSearch from "../../../../component/InputSearch";
import {searchPhieuKeHoach} from "../services/services";

interface Props {
  show: boolean;
  onHide: () => void;
  onOk?: (value?: any, source?: string) => void;
  initialValues: any;
  type: TypeYeuCau;
  titleList?: string;
  title?: string;
}

const DialogSelectList = (props: Props) => {
  const {
    show, onHide, type, onOk = () => {
    },
    titleList,
    title,
  } = props;
  const {setIsLoading} = useContext(AppContext);
  const [searchData, setSearchData] = useState<any>();
  const [rowsPerPage, setRowsPerPage] = useState<number>(20);
  const [page, setPage] = useState<number>(DEFAULT_PAGE_INDEX);
  const [configTable, setConfigTable] = useState<any>({
    totalPages: 0,
    totalElements: 0,
    numberOfElements: 0,
  });
  const [dsItems, setDsItems] = useState<any>([{}]);

  const updatePageData = async () => {
    try {
      setIsLoading(true);
      const {data} = await searchPhieuKeHoach({
        ...searchData,
        keyword: searchData?.keyword?.trim() || null,
        pageSize: rowsPerPage,
        pageIndex: page,
      });
      if (CODE.SUCCESS === data.code) {
        setDsItems(data?.data?.content || []);
        setConfigTable({
          totalPages: Math.ceil(data.data.pageable.totalElements / data.data.pageable.pageSize),
          totalElements: data?.data?.pageable?.totalElements,
        })
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleChangeSearchData = (e: ChangeEvent<HTMLInputElement>) => {
    setSearchData({
      ...searchData,
      [e.target.name]: e.target.value,
    });
  };

  const handlerSearchKeyWorld = () => {
    setPage(DEFAULT_PAGE_INDEX);
    setRowsPerPage(20);
    updatePageData()
  }

  const handleFormSubmit = async (values: any) => {
    const dataSubmit = {
      ...values,
    };
    onOk(dataSubmit, type.formVatTu)
    onHide()
  };

  return (
    <Modal
      centered
      show={show}
      // onHide={onHide}
      size="lg"
      className="page-full spaces h-calc-vh-50"
    >
      <ModelHeader onHide={onHide} title={title}/>
      <Modal.Body className="spaces p-0 bg-white">
        <div className="d-flex spaces pr-8 mt-6 ml-10 bg-white justify-content-between align-items-center mb-6">
          <div className="flex-grow-1 ">
            <InputSearch
              name="keyword"
              value={searchData?.keyword || ''}
              placeholder="Tìm kiếm"
              handleChange={handleChangeSearchData}
              handleSearch={() => handlerSearchKeyWorld()}
              handleKeyDown={(e: React.KeyboardEvent) => e.key === KEY.ENTER && handlerSearchKeyWorld()}
              className="spaces h-31 pr-4 radius-3"
            />
          </div>
          <div className=" bg-white flex align-items-center mr-13 spaces">
            <div className="d-flex">
              <div className="spaces  mt-6  ml-10">
                <span className="text-lable-input min-w-100px">Phòng ban</span>
              </div>
              <AutocompleteObjectV2
                options={[{}]}
                isSearchDefauilt={true}
                name={"WmsCode"}
                onChange={(options: any) => console.log(options)}
                className="autocomplete-custom-renderform pl-5 radius spaces min-w-200 h-29"
              />
            </div>
          </div>
        </div>
        {titleList && <div className="flex bg-white spaces width-100 ">
					<h4 className="text-title text-pri fw-bold fs-4 spaces mb-0 px-10 min-w-180">
            {titleList}
					</h4>
				</div>}
        <div className="spaces px-10">
          <div className="spaces bg-white mb-0">
            <TableCustom<any>
              className={`spaces`}
              data={dsItems}
              columns={KeHoachDialogColumns}
              verticalScroll={true}
              selectionMode={SELECTION_MODE.MULTI}
              getSelectedRowsData={(data: any) => {
                console.log(data)
              }}
            />
            <TablePagination
              handlePagesChange={handlePagesChange}
              handleRowsPerPageChange={handleRowsPerPageChange}
              rowsPerPage={rowsPerPage}
              rowsForPage={rowsForPage}
              page={page}
              setPage={setPage}
              setRowsPerPage={setRowsPerPage}
              totalPages={Number(configTable.totalPages)}
              totalElements={configTable.totalElements}
              numberOfElements={configTable.numberOfElements}
              hideTotalElements
              className="border border-0"
            />
          </div>
          <div className="spaces mt-10 pb-10 d-flex justify-content-end w-100 bg-white spaces">
            <Button onClick={handleFormSubmit} className="btn btn-fill min-w-120px spaces mx-3">
              <IconButtonSave/> {`Thêm`}
            </Button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  )
};

export default DialogSelectList;
